import { Application } from "@hotwired/stimulus";
import Appsignal from "@appsignal/javascript";
import { installErrorHandler } from "@appsignal/stimulus";
import * as ActiveStorage from "@rails/activestorage";

const application = Application.start();
ActiveStorage.start();

const appsignal_key_meta = document.head.querySelector("meta[name=appsignal_key]");
const appsignal_revision_meta = document.head.querySelector("meta[name=appsignal_revision]");

if (appsignal_key_meta) {
  let revision = "unknown";
  if (appsignal_revision_meta) {
    revision = appsignal_revision_meta.content;
  }

  const appsignal = new Appsignal({
    key: appsignal_key_meta.content,
    revision: revision,
  });

  installErrorHandler(appsignal, application);
}

application.debug = false;
window.Stimulus = application;

export { application };
